import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import Color from "color";
import { List, AutoSizer } from "react-virtualized";
import { useTheme, Typography } from "@material-ui/core";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import Search from "./Search";
import { Filter } from "./Filter";
import PaneHeader from "../../../components/layout/Pane/PaneHeader";
import { PatronContext } from "../../../contexts/PatronContext";
import { PaneContext } from "../../../contexts/PaneContext";
import { UserContext } from "../../../contexts/UserContext";

const PatronList = () => {
  const [filteredPatrons, setFilteredPatrons] = useState([]);
  const [modal, setModal] = useState(false);
  const { Site } = useContext(UserContext);
  const patronLabel =
    Site.siteType === 0 || Site.siteType === 5 ? "students" : "Staff";
  const { patron, patrons, selectPatron } = useContext(PatronContext);
  const { toggleNewPatronMode, changeTab } = useContext(PaneContext);
  const { palette } = useTheme();

  const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => {
    const p = filteredPatrons[index];

    const content = !isScrolling ? (
      <ListItemContent noWrap>
        <Bold>{p.lastName}</Bold>, {p.firstName} {p.externalID}{" "}
        {(Site.siteType === 0 && p.yearGroup > 0) ||
        (Site.siteType === 5 && p.yearGroup > 0) ? (
          <Bold>
            {p.yearGroup < 13
              ? `[Y${p.yearGroup}]`
              : p.yearGroup == 13
              ? `[Kindy]`
              : p.yearGroup == 14
              ? "[Pre-Pri]"
              : "[Pre-Kindy]"}
          </Bold>
        ) : (
          <></>
        )}
      </ListItemContent>
    ) : (
      <ListItemContent>Loading</ListItemContent>
    );

    return (
      <ListItem
        key={key}
        colour={palette.secondary.main}
        onClick={() => {
          toggleNewPatronMode(false);
          changeTab(0);
          selectPatron(p);
        }}
        active={patron && p.PatronID === patron.PatronID ? true : false}
        style={style}
      >
        {content}
      </ListItem>
    );
  };

  const search = (e) => {
    const { value } = e.target;
    const filter = value.toUpperCase();

    let filteredArray = [];

    for (let i = 0; i < patrons.length; i++) {
      if (
        patrons[i].lastName.toUpperCase().includes(filter) ||
        patrons[i].firstName.toUpperCase().includes(filter) ||
        patrons[i].externalID.toUpperCase().includes(filter)
      ) {
        filteredArray.push(patrons[i]);
      }
    }
    setFilteredPatrons(filteredArray);
  };

  useEffect(() => {
    setFilteredPatrons(patrons);
  }, [patrons]);

  return patrons.length > 0 ? (
    <Container>
      <PaneHeader
        icon={<PeopleAltIcon />}
        title={patronLabel}
        data={
          filteredPatrons.length > 0 ? filteredPatrons.length : patrons.length
        }
        search
        openModal={() => setModal(true)}
        setFilteredPatrons={setFilteredPatrons}
        filter={
          <Filter
            filteredPatrons={filteredPatrons}
            setFilteredPatrons={setFilteredPatrons}
            isOpen={modal}
            close={() => setModal(false)}
          />
        }
      >
        <Search onChange={search} />
      </PaneHeader>
      <AutoSizer>
        {({ height, width }) => (
          <StyledList
            height={height - 70}
            width={width - 2}
            rowCount={filteredPatrons.length}
            rowHeight={30}
            rowRenderer={rowRenderer}
          />
        )}
      </AutoSizer>
    </Container>
  ) : (
    <NoPatrons>No {patronLabel}</NoPatrons>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledList = styled(List)`
  overflow-y: scroll;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  cursor: pointer;
  text-transform: uppercase;
  color: ${(props) => props.colour};
  border-bottom: 1px solid ${(props) => Color(props.colour).fade(0.75).string()};
  &:first-child {
    border-top: 1px solid ${(props) => Color(props.colour).fade(0.75).string()};
  }
  background-color: ${(props) =>
    props.active
      ? Color(props.colour).fade(0.65).string()
      : Color(props.colour).fade(0.9).string()};
  &:hover {
    background-color: ${(props) => Color(props.colour).fade(0.75).string()};
  }
  &:active {
    background-color: ${(props) => Color(props.colour).fade(0.5).string()};
  }
`;

const ListItemContent = styled(Typography)``;

const Bold = styled.span`
  font-weight: 700;
`;

const NoPatrons = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6rem;
`;

export default PatronList;
